import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 lg:py-32 bg-brand-dark relative overflow-hidden border-t border-brand-border" data-id="element-90">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-92">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-light text-white mb-5 lg:mb-8 leading-tight tracking-tight" data-id="element-93">
            Ready to join the Lima Dental VIP Plan?
          </h2>
          <p className="text-base lg:text-xl text-brand-muted font-light mb-8 lg:mb-12 max-w-2xl mx-auto" data-id="element-94">
            $500/year — Affordable, premium dental care for you and your family.
            No insurance needed.
          </p>

          <button onClick={scrollToForm} className="bg-white hover:bg-white/90 text-brand-dark font-medium py-3 lg:py-4 px-10 lg:px-12 rounded-full transition-all text-base lg:text-lg" data-id="element-95">
            Join the VIP Plan Today
          </button>
        </motion.div>
      </div>
    </section>;
}